import './Loader.sass';

import { AlignItems, CFlex, JustifyContent } from '@dark-portal/react-components';
import React from 'react';

export const Loader = (): React.JSX.Element => {
  return (
    <CFlex
      fullWidth
      fullHeight
      justifyContent={JustifyContent.Center}
      alignItems={AlignItems.Center}
      style={{ height: '100dvh' }}
    >
      <div className="loader triangle">
        <svg viewBox="0 0 86 80">
          <polygon points="43 8 79 72 7 72"></polygon>
        </svg>
      </div>
    </CFlex>
  );
};
